/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import ServiceSection from "../../../../../components/Sections/Generic/ServiceSection/ServiceSection";
import Container from "../../../../../components/Container/Container";
import KindsOfDivorceSection from "../../../../../components/Sections/Divorce/KindsOfDivorceSection/KindsOfDivorceSection";
import ProcedureDivorceSection from "../../../../../components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import SettlementTimeSection from "../../../../../components/Sections/Settlement/SettlementTimeSection/SettlementTimeSection";
import LoggedInCheckin from "../../../../../components/Checkin/LoggedInCheckin/LoggedInCheckin";
import DivorcePlannerSection from "../../../../../components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import NoWinNoFeeSection from "../../../../../components/Sections/Settlement/NoWinNoFeeSection/NoWinNoFeeSection";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import OurService from "@/src/components/OurService/OurService";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { trafficTeaserCards } from "@/src/services/landingPageService";
import HowItWorksSectionTraffic from "@/src/components/Sections/Traffic/HowItWorksSection/HowItWorksSectioTraffic";
import IncorrectPenaltySection from "@/src/components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import TrafficCostRiskSection from "@/src/components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import ControlledAccordionSection from "@/src/components/Sections/Generic/ControlledAccordionSection/ControlledAccordionSection";
import accordionContentDismissal from "@/src/components/ControlledAccordion/accordionContentDismissal";

const LpModules = () => {
  return (
    <Layout minimal={true}>
      <LandingPageTeaser headline={"Beispiel einer Landingpage"} subheadline={"Hero-Titel, Unterzeile und Auswahlkarten"} hasTeaserButton={false}>
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <HowItWorksSectionTraffic />
      <IncorrectPenaltySection />
      <TrafficCostRiskSection />
      <AttorneySection />
      <ProcedureDivorceSection />
      <Container>
        <LoggedInCheckin
          checkinHeading={"Wir führen Sie Schritt für Schritt durch Ihre Scheidung"}
          buttonLink={"/servicewelt"}
          bullet1={"Kostenloses Erstgespräch"}
          bullet2={"Scheidungskosten berechnen"}
          bullet3={"Scheidungsantrag stellen"}
          idPrefix={"top"}
          color={"grey"}
        />
      </Container>
      <KindsOfDivorceSection />
      <CustomerFeedback />
      <AdvantagesLegalbirdAttorneySection />
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} />
      <OurService />
      <DivorcePlannerSection />
      <TeamSection headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"} subHeadline={"Wir kümmern uns persönlich um Sie"} />
      <NoWinNoFeeSection />
      <SettlementTimeSection />
      <ControlledAccordionSection contentList={accordionContentDismissal} idPrefix={"modules"} name={"Module"} heading={"Häufige Fragen"} />
      <ServiceSection />
      <TeamSection isSubsection={true} />
      <PartnersSection />
    </Layout>
  );
};

export default LpModules;
